<div class="orderRecap">
  @if (email) {
    <span class="recapChip">
      <svg class="recapChipIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4 6h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zM3.5 7l8.5 6 8.5-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" />
      </svg>
      <span class="recapChipLabel"><span class="recapChipKey">{{ 'CONFIRMATION.EMAIL_ADDRESS' | translate }}</span> {{ email }}</span>
    </span>
  }
  <!-- Date and time stay on the same line, date first -->
  @if (date || time) {
    <div class="recapChipGroup">
      @if (date) {
        <span class="recapChip">
          <svg class="recapChipIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M7 3v3M17 3v3M4 9h16M6 5h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" />
          </svg>
          <span class="recapChipLabel"><span class="recapChipKey">{{ 'TIME_SLOTS.DATE' | translate }}</span> {{ date | date:'mediumDate' }}</span>
        </span>
      }
      @if (time) {
        <span class="recapChip">
          <svg class="recapChipIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 7v5l3 2M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" />
          </svg>
          <span class="recapChipLabel"><span class="recapChipKey">{{ 'TIME_SLOTS.TIME' | translate }}</span> {{ time }}</span>
        </span>
      }
    </div>
  }
</div>
